//Pages
import Profile from "views/Pages/Profile.jsx";
import LoginPage from "views/Pages/LoginPage.jsx";
import ForgotPasswordPage from "views/Pages/ForgotPasswordPage.jsx";
import EnterOTPPage from "views/Pages/EnterOTPPage.jsx";
import CreatePasswordPage from "views/Pages/CreatePasswordPage.jsx";
//Tables
import { VendorTables, LenderTables, ProductTables, OrderTables, ResponseTables, EmailTables, AttachmentTables, } from "views/Tables";
//Forms
////Add Forms
import { VendorForm, LenderForm, OrderForm, ProductForm, ResponseForm, EmailForm, } from "views/Forms";
////Edit Forms
import { EditVendorForm, EditLenderForm, EditOrderForm, EditProductForm, EditResponseForm, EditEmailForm, } from "views/Forms";
//Icons
import { Group, ListAlt, } from "@material-ui/icons";

const dashRoutes = [
  {
    path: "/login-page",
    name: "Login Page",
    component: LoginPage,
    layout: "/auth"
  },
  {
    path: "/forgot-page",
    name: "Forgot Password Page",
    component: ForgotPasswordPage,
    layout: "/auth"
  },
  {
    path: "/enter-otp-page",
    name: "Enter OTP Page",
    component: EnterOTPPage,
    layout: "/auth"
  },
  {
    path: "/create-password-page",
    name: "Create Password Page",
    component: CreatePasswordPage,
    layout: "/auth"
  },
  {
    path: "/profile",
    name: "Profile",
    icon: Group,
    component: Profile,
    layout: "/admin",
  },
  {
    path: "/vendors",
    name: "Vendors",
    icon: Group,
    component: VendorTables,
    layout: "/admin",
    isNavbarItem: true,
    exact: true
  },
  {
    path: "/vendor/add",
    name: "Vendor Form",
    component: VendorForm,
    layout: "/admin"
  },
  {
    path: "/vendor/edit/:vendorId",
    name: "Edit Vendor Form",
    component: EditVendorForm,
    layout: "/admin"
  },
  {
    path: "/vendors/:vendorId/lenders",
    name: "Lenders",
    icon: Group,
    component: LenderTables,
    layout: "/admin"
  },
  {
    path: "/lender/add/:vendorId",
    name: "Lender Form",
    component: LenderForm,
    layout: "/admin"
  },
  {
    path: "/lender/vendor/:vendorId/edit/:lenderId",
    name: "Edit Lender Form",
    component: EditLenderForm,
    layout: "/admin"
  },
  {
    path: "/vendor/:vendorId/lender/:lenderId/products",
    name: "Product",
    component: ProductTables,
    layout: "/admin"
  },
  {
    path: "/vendor/:vendorId/lender/:lenderId/product-add",
    name: "Add Product",
    component: ProductForm,
    layout: "/admin"
  },
  {
    path: "/vendor/:vendorId/lender/:lenderId/edit/:productId",
    name: "Edit Product",
    component: EditProductForm,
    layout: "/admin"
  },
  {
    path: "/vendor/:vendorId/lender/:lenderId/inputs/:productId",
    name: "Response Input",
    component: ResponseTables,
    layout: "/admin"
  },
  {
    path: "/vendor/:vendorId/lender/:lenderId/response-add/:productId",
    name: "Add Response",
    component: ResponseForm,
    layout: "/admin"
  },
  {
    path: "/vendor/:vendorId/lender/:lenderId/response-edit/:productId/response/:responseId",
    name: "Edit Response",
    component: EditResponseForm,
    layout: "/admin"
  },
  {
    path: "/vendor/:vendorId/lender/orders/:lenderId",
    name: "Orders",
    icon: ListAlt,
    component: OrderTables,
    layout: "/admin",
  },
  {
    path: "/vendor/:vendorId/lender/:lenderId/order-add",
    name: "Order Form",
    component: OrderForm,
    layout: "/admin"
  },
  {
    path: "/vendor/:vendorId/lender/:lenderId/order/:orderId/edit",
    name: "Orders",
    icon: ListAlt,
    component: EditOrderForm,
    layout: "/admin",
  },
  {
    path: "/vendor/emails/:vendorId",
    name: "Vendor Emails",
    icon: Group,
    component: EmailTables,
    layout: "/admin"
  },
  {
    path: "/email/add/:vendorId",
    name: "Add Email Form",
    component: EmailForm,
    layout: "/admin"
  },
  {
    path: "/email/vendor/:vendorId/edit/:credentialId",
    name: "Edit Email Form",
    component: EditEmailForm,
    layout: "/admin"
  },
  {
    path: "/vendor/:vendorId/lender/:lenderId/order/:orderId/attachments",
    name: "Order Attachments",
    icon: Group,
    component: AttachmentTables,
    layout: "/admin"
  },
];

export default dashRoutes;
